import Link from 'next/link';
import { FC } from 'react';
import styled from 'styled-components';

import { SusnetImage } from '~/components/_wrapper/SusnetImage';

import {
  StyledMain,
  StyledImage,
  StyledTitle,
  StyledBody,
  StyledRecommendTitle,
  StyledRecommend,
  StyledRecommendRow,
  StyledRecommendText,
  StyledMoreTitle,
  StyledLinks,
  StyledLink,
  StyledLinkBody,
  StyledLinkTitle,
  StyledLinkLogo,
  StyledLinkText,
  StyledLinkImage,
} from './main.styles';

const RECOMMEND_TEXTS: string[] = [
  'NPOや社会的事業者と協業を検討している',
  'ソーシャルセクターの最新動向を知りたい',
  'サステナビリティ活動の幅を広げたい',
];

type Props = {
  submitted: boolean;
};

const LINKS: {
  link: string;
  title: string;
  logo: string;
  text: string;
  image: string;
}[] = [
  {
    link: '/',
    title: '共助共創プラットフォーム',
    logo: '/survey/susnet.png',
    text: '社会課題の解決のため、「誰が」「どこで」「何をしているのか」を可視化し、最適な協働を支える',
    image: '/survey/susnet-image.png',
  },
  {
    link: 'https://ichicommons.com',
    title: '運営会社',
    logo: '/survey/corp.png',
    text: 'NPO/社会的事業者・企業・個人の共助共創を支え、社会課題が解決されるサイクルを構築する',
    image: '/survey/corp-image.png',
  },
];

export const Main: FC<Props> = ({ submitted }) => {
  return (
    <StyledMain>
      <StyledImage>
        <SusnetImage src={'/survey/top.png'} fill={true} alt={''} />
      </StyledImage>
      <StyledTitle>
        {submitted
          ? 'フォーム送信ありがとうございます。'
          : '社会的事業を行う非営利・営利法人の実態調査レポート2023'}
      </StyledTitle>
      <StyledBody>
        {submitted
          ? '入力いただいたご連絡先へ弊社担当より資料を送付いたします。今しばらくお待ちいただけますと幸いです。'
          : `前調査から5年が経った今、改めて地域社会の現場で社会課題解決の中心的役割を担われている組織の体制、財務、広報、人材、連携に関するご活動の現状と課題を調査分析しました。\n\n本調査結果が、内閣府をはじめとした公的機関、⺠間企業、業界団体、中間支援機関をはじめとしたステークホルダーに広く共有されることで、社会課題解決を目的としたセクター間のさらなる連携が促進されることを期待しています。`}
      </StyledBody>
      {submitted ? (
        <div>
          <StyledMoreTitle>関連リンク</StyledMoreTitle>
          <StyledLinks>
            {LINKS.map((l, i) => (
              <Link href={l.link} key={i}>
                <StyledLink>
                  <StyledLinkBody>
                    <StyledLinkTitle>{l.title}</StyledLinkTitle>
                    <StyledLinkLogo>
                      <SusnetImage src={l.logo} fill={true} alt={''} />
                    </StyledLinkLogo>
                    <StyledLinkText>{l.text}</StyledLinkText>
                  </StyledLinkBody>
                  <StyledLinkImage>
                    <SusnetImage src={l.image} fill={true} alt={''} />
                  </StyledLinkImage>
                </StyledLink>
              </Link>
            ))}
          </StyledLinks>
        </div>
      ) : (
        <div>
          <StyledRecommendTitle>こんな方におすすめ</StyledRecommendTitle>
          <StyledRecommend>
            {RECOMMEND_TEXTS.map((t, i) => (
              <StyledRecommendRow key={i}>
                <SusnetImage src={'/survey/check-square.svg'} width={24} height={24} />
                <StyledRecommendText>{t}</StyledRecommendText>
              </StyledRecommendRow>
            ))}
          </StyledRecommend>
          <StyledMoreTitle>より詳しく知りたい方はこちらから</StyledMoreTitle>
          <a
            href='https://press.ichicommons.com/ichicommons/survey2023/'
            target='_blank'
            rel='noreferrer'
          >
            <SusnetImage src={'/survey/banner.png'} width={251} height={156} />
          </a>
        </div>
      )}
    </StyledMain>
  );
};
